import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Svg.module.scss';

const Svg = ({
  id = null,
  glyph = '',
  ariaLabel = '',
  iconId = '',
  fill = '#adb5bd',
  width = 20,
  height = 20,
  className = '',
  sendEventToGA = () => {},
  wrapperClose = '',
}) => {
  const classes = classNames(styles.icon, {
    [styles[`${glyph}`]]: !!glyph,
    [className]: !!className,
    [styles['close-size']]: wrapperClose === 'close-size',
  });
  return (
    <span id={id} className={classes} aria-label={ariaLabel} onMouseOver={sendEventToGA} onFocus={() => {}}>
      <svg fill={fill} viewBox={`0 0 ${width} ${height}`} aria-hidden="false" width={width} height={height}>
        <use href={`/auth/v1/static/icons_sprite_v1.svg#${iconId}`} />
      </svg>
    </span>
  );
};

Svg.propTypes = {
  id: PropTypes.string,
  glyph: PropTypes.string,
  ariaLabel: PropTypes.string,
  iconId: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  sendEventToGA: PropTypes.func,
  wrapperClose: PropTypes.string,
};

export default Svg;
